import { useMarketingLang } from "../i18n.jsx";

export default function TwoVerticals() {
  const { t } = useMarketingLang();
  return (
    <section className="section-y border-t-[0.5px] border-white/[0.06]">
      <div className="container-page">
        <p className="eyebrow mb-6">{t('twoVerticals.eyebrow')}</p>
        <h2 className="h-section max-w-[680px] text-ink">
          {t('twoVerticals.title')}
        </h2>

        <div className="mt-10 grid md:grid-cols-2 gap-4">
          <VerticalCard
            label={t('twoVerticals.hydrogen.label')}
            bullets={t('twoVerticals.hydrogen.bullets')}
          />
          <VerticalCard
            label={t('twoVerticals.dataCenters.label')}
            bullets={t('twoVerticals.dataCenters.bullets')}
          />
        </div>
      </div>
    </section>
  );
}

function VerticalCard({
  label,
  bullets,
}: {
  label: string;
  bullets: string[];
}) {
  return (
    <article
      className="rounded-2xl p-8 border-hairline-base transition-colors hover:border-white/15"
      style={{
        background:
          "linear-gradient(180deg, rgba(77,212,232,0.05), rgba(77,212,232,0.01))",
        borderColor: "rgba(77,212,232,0.18)",
      }}
    >
      <p
        className="font-mono text-[11px] uppercase mb-5 text-teal"
        style={{ letterSpacing: "0.21em" }}
      >
        {label}
      </p>
      <ul className="flex flex-col gap-3">
        {bullets.map((b) => (
          <li
            key={b}
            className="flex items-start gap-3 text-[15px] text-ink/90 leading-[1.5]"
          >
            <span aria-hidden className="text-teal mt-[1px]">
              →
            </span>
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </article>
  );
}
